module.exports = __webpack_public_path__ + "img/sebrae_turismo_colorida.6fd46eb8.jpg";